function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useRef } from "react";
import classnames from "classnames";
import Big from "big.js";
import { mergeProps } from "../../utils/mergeProps";
import { withNativeProps } from "../../utils/with-native-props";
import { getDecimalLen, sortValue } from "../../utils/number-lib";
import { usePropsValue } from "../../utils/use-props-value";
import { nearest } from "../../utils/nearest";
import Thumb from "./thumb";
import Ticks from "./Ticks";
import Marks from "./Marks";
var classPrefix = "tc-slider";
var defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  ticks: false,
  range: false,
  showTicks: false,
  popover: false,
  residentPopover: false
};
var Slider = function Slider(p) {
  var props = mergeProps(defaultProps, p);
  var defaultValue = props.defaultValue,
    disabled = props.disabled,
    icon = props.icon,
    marks = props.marks,
    max = props.max,
    min = props.min,
    onChange = props.onChange,
    range = props.range,
    step = props.step,
    showTicks = props.showTicks,
    className = props.className,
    style = props.style,
    value = props.value,
    popover = props.popover,
    residentPopover = props.residentPopover;
  var trackRef = useRef(null);
  // 限制退拽过程的点击
  var dragLockRef = useRef(0);
  var valueBeforeDragRef = useRef();
  var propsValue = value;
  if (range && typeof value === "number") {
    propsValue = [0, value];
  }
  function reverseValue(current) {
    var mergedDecimalLen = Math.max(getDecimalLen(step), getDecimalLen(current[0]), getDecimalLen(current[1]));
    return props.range ? current.map(function (v) {
      return Big(Big(v).toFixed(mergedDecimalLen)).toNumber();
    }) : Big(Big(current[1]).toFixed(mergedDecimalLen)).toNumber();
  }
  function onAfterChange(v) {
    var _a;
    (_a = props.onAfterChange) === null || _a === void 0 ? void 0 : _a.call(props, reverseValue(v));
  }
  function convertValue(current) {
    return range ? current : [min, current];
  }
  // 劫持控制实际的value值
  var _usePropsValue = usePropsValue({
      value: propsValue,
      defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : range ? [min, min] : min,
      onChange: onChange
    }),
    _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
    rawValue = _usePropsValue2[0],
    setRawValue = _usePropsValue2[1];
  // 处理[first,last]数组
  var sliderValue = sortValue(convertValue(rawValue));
  var setSliderValue = function setSliderValue(v) {
    var next = sortValue(v);
    var current = sliderValue;
    if (next[0] === current[0] && next[1] === current[1]) return;
    setRawValue(reverseValue(next));
  };
  var pointList = useMemo(function () {
    if (marks) {
      return Object.keys(marks).map(parseFloat).sort(function (a, b) {
        return a - b;
      });
    } else {
      var points = [];
      for (var i = Big(min); i.lte(max); i = i.plus(step)) {
        points.push(i.toNumber());
      }
      return points;
    }
  }, [marks, step, min, max]);
  var getValueByPosition = function getValueByPosition(position) {
    var newPosition = Math.min(max, Math.max(min, position));
    var current = min;
    if (pointList.length) {
      current = nearest(pointList, newPosition);
    } else {
      var lengthPerStep = 100 / ((max - min) / step);
      var steps = Math.round(newPosition / lengthPerStep);
      current = steps * lengthPerStep * (max - min) * 0.01 + min;
    }
    return current;
  };
  var onTrackClick = function onTrackClick(event) {
    var _a;
    if (dragLockRef.current > 0) return;
    event.stopPropagation();
    if (disabled) return;
    var track = trackRef.current;
    if (!track) return;
    var sliderOffsetLeft = (_a = track.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.left;
    var position = (event.clientX - sliderOffsetLeft) / Math.ceil(track.offsetWidth) * (max - min) + min;
    var targetValue = getValueByPosition(position);
    var nextSliderValue;
    if (range) {
      if (Math.abs(targetValue - sliderValue[0]) > Math.abs(targetValue - sliderValue[1])) {
        nextSliderValue = [sliderValue[0], targetValue];
      } else {
        nextSliderValue = [targetValue, sliderValue[1]];
      }
    } else {
      nextSliderValue = [props.min, targetValue];
    }
    setSliderValue(nextSliderValue);
    onAfterChange(nextSliderValue);
  };
  var fillSize = "".concat(100 * (sliderValue[1] - sliderValue[0]) / (max - min), "%");
  var start = 100 * (sliderValue[0] - min) / (max - min);
  var fillStart = "".concat(Math.min(100, Math.max(start, 0)), "%");
  // 处理拖拽更新
  var handleDrag = function handleDrag(_ref) {
    var position = _ref.position,
      first = _ref.first,
      last = _ref.last,
      index = _ref.index;
    if (first) {
      // 锁定
      dragLockRef.current += 1;
      valueBeforeDragRef.current = sliderValue;
    }
    var val = getValueByPosition(position);
    var valueBeforeDrag = valueBeforeDragRef.current;
    if (!valueBeforeDrag) return;
    var next = _toConsumableArray(valueBeforeDrag);
    next[index] = val;
    // 更新值
    setSliderValue(next);
    if (last) {
      onAfterChange(next);
      window.setTimeout(function () {
        // 解锁
        dragLockRef.current -= 1;
      }, 100);
    }
  };
  var renderThumb = function renderThumb(index) {
    return /*#__PURE__*/React.createElement(Thumb, {
      key: index,
      value: sliderValue[index],
      min: min,
      max: max,
      disabled: disabled,
      trackRef: trackRef,
      icon: icon,
      popover: popover,
      residentPopover: residentPopover,
      onDrag: function onDrag(position, first, last) {
        handleDrag({
          position: position,
          first: first,
          last: last,
          index: index
        });
      },
      "aria-label": props["aria-label"]
    });
  };
  var compCls = classnames(classPrefix, _defineProperty({}, "".concat(classPrefix, "-disabled"), disabled), className);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: compCls,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-track-container"),
    onClick: onTrackClick
  }, marks && /*#__PURE__*/React.createElement(Marks, {
    min: min,
    max: max,
    marks: marks,
    lowerBound: sliderValue[0],
    upperBound: sliderValue[1]
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-track"),
    onClick: onTrackClick,
    ref: trackRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-fill"),
    style: {
      width: fillSize,
      left: fillStart
    }
  }), !!showTicks && /*#__PURE__*/React.createElement(Ticks, {
    points: pointList,
    min: min,
    max: max,
    lowerBound: sliderValue[0],
    upperBound: sliderValue[1]
  }), range && renderThumb(0), renderThumb(1)))));
};
Slider.defaultProps = defaultProps;
export default Slider;